import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Header as ReactHeader, Button } from '@3plearning/react-components';
import StudentAccess from '@3plearning/student-restrict-access';
import css from './entry-app.scss';
import Resources from '../../helpers/resources';
import usePreview from '../../helpers/hooks/use-preview';
import { QuickPreview } from '../../helpers/icon-dictionary';
import { durationTypes, isAssessmentsReadOnly } from '../../helpers/utils';
import { getAllLearningJourneys } from '../upf-assign/upf-assign-util';
import { theme } from './entry-app';
import { getLocale } from '../../helpers/locale';
import { useTracking } from '../../analytics';

const Header = ({ i18n }) => {
  const topics = useSelector(state => state.UPFAssignReducer.topics);
  const selectedClassRoom = useSelector(state => state.UPFAssignReducer.selectedClassRoom);
  const selectedClassRoomGroup = useSelector(state => state.UPFAssignReducer.selectedGroup);
  const [isLoading, handlePreview] = usePreview(getAllLearningJourneys(topics, true));
  const [localeCdnBaseUrl, setLocaleCdnBaseUrl] = useState();
  const { trackQuickPreview, trackGoToNewAssessments } = useTracking();

  const openLegacyAssessments = () => {
    trackGoToNewAssessments();
    const { authToken } = Resources.env;
    const LegacyAssessmentsUrl = `${window._env_.LegacyAssessmentsBaseUrl}?authToken=${authToken}`;
    window.open(LegacyAssessmentsUrl, '_blank');
  };

  useEffect(() => {
    setLocaleCdnBaseUrl(window._env_.studentTaskLocaleCdnUrl);
  }, []);

  const locale = getLocale();

  const classId = selectedClassRoom?.value || -1;
  const groupId = selectedClassRoomGroup?.value || -1;
  const classroomReportApiUrl = window._env_.ClassroomReportApiUrl;

  return (
    <ReactHeader
      title={i18n.t`Assign & Review`}
      subtitle={i18n.t`Assessments`}
      className={css.header}
    >
      <div className={css['buttons-container']}>
        {!isAssessmentsReadOnly() && localeCdnBaseUrl && classroomReportApiUrl && <StudentAccess
          apiBaseUrl={classroomReportApiUrl}
          Resources={Resources}
          classId={classId}
          groupId={groupId}
          i18n={i18n}
          theme={theme}
          locale={locale}
          localeCdnBaseUrl={localeCdnBaseUrl}
        />}
        <Button
          alignIcon="LEFT"
          icon={QuickPreview}
          onClick={() => {
            trackQuickPreview();
            handlePreview(
              60 * 60,
              durationTypes.PER_ASSIGNMENT,
              false
            );
          }}
          primary
          disabled={isLoading}
          text={i18n.t`Quick Preview`}
          type={Button.LOZENGE}
        />

        <span
          className={css.tooltip}
          data-tooltip={i18n.t`We've upgraded Assessments. Create, assign, and review assessments in the new area.`}
        >
          <Button
            text={i18n.t`Go to New Assessments`}
            type={Button.LOZENGE}
            onClick={openLegacyAssessments}
          />
        </span>
      </div>
    </ReactHeader>
  );
};
Header.propTypes = {
  i18n: PropTypes.object
};
export default Header;
